import { SidebarMenuItem } from '../ts-types';
// Enum for allowed sidebar sections on monitoring subdomains
export enum MonitoringSidebarAllowed {
  DASHBOARDS = 'Dashboards',
  DASHBOARD = 'Dashboard', // Add this to handle singular "Dashboard" from API
  ACCESS_MANAGEMENT = 'Access Management',
}

// Utility to filter sidebar menu items for monitoring subdomains (keep only monitoring items)
export function filterMonitoringSidebarMenuItems(
  menuItems: SidebarMenuItem[]
): SidebarMenuItem[] {
  return menuItems
    .filter(
      (item) =>
        item.title === MonitoringSidebarAllowed.DASHBOARDS ||
        item.title === MonitoringSidebarAllowed.DASHBOARD || // Check for both singular and plural
        item.title === MonitoringSidebarAllowed.ACCESS_MANAGEMENT
    )
    .map((item) => {
      // For Access Management, keep all children
      if (
        item.title === MonitoringSidebarAllowed.ACCESS_MANAGEMENT &&
        (item as any).children
      ) {
        return { ...item, children: (item as any).children };
      }
      // For Dashboards/Dashboard, filter children to only include monitoring dashboard items
      if (
        (item.title === MonitoringSidebarAllowed.DASHBOARDS ||
          item.title === MonitoringSidebarAllowed.DASHBOARD) &&
        (item as any).children
      ) {
        const filteredChildren = (item as any).children.filter((child: any) => {
          // Only keep items with monitoring dashboard links
          return (
            child.link &&
            (child.link === '/monitoring-dashboard' ||
              child.link.startsWith('/monitoring-dashboard/'))
          );
        });
        return { ...item, children: filteredChildren };
      }
      // For other items, keep as is
      return { ...item };
    });
}

// Utility to filter sidebar menu items for regular domains (exclude monitoring items)
export function filterRegularDomainSidebarMenuItems(
  menuItems: SidebarMenuItem[]
): SidebarMenuItem[] {
  return menuItems.map((item) => {
    // For all items with children, filter out monitoring dashboard items
    if ((item as any).children && Array.isArray((item as any).children)) {
      const filteredChildren = (item as any).children.filter((child: any) => {
        // Exclude items with monitoring dashboard links
        return !(
          child.link &&
          (child.link === '/monitoring-dashboard' ||
            child.link.startsWith('/monitoring-dashboard/'))
        );
      });
      return { ...item, children: filteredChildren };
    }
    // For items without children, keep as is
    return { ...item };
  });
}
